import { MyqqRouteState } from "./router.models";

export const routerStateConfig = {
  stateKey: "ROUTER",
};

export const INITIAL_STATE: MyqqRouteState = {
  state: { url: "/" },
};
